<template>
    <v-container>
        <SpecimenDetails>
        </SpecimenDetails>
        <MedicalRecordEntry :medicalRecordID="medicalRecordID">
        </MedicalRecordEntry>
    </v-container>
</template>

<script>
import moment from 'moment';
import validationRules from "../../helpers/validationrules";
import * as auth from '@/services/auth';
import permissions from 'comunet-btg-utah-repository-shared/permissions';
import constants from 'comunet-btg-utah-repository-shared/constants';
import { mapState } from 'vuex';
import MedicalRecordEntry from "./MedicalRecordEntry.vue";
import MedicalRecordList from "./MedicalRecordsList.vue";
import AddMedicalRecord from "./AddMedicalRecord.vue";
import SpecimenDetails from "./SpecimenDetails.vue";

export default {
    components: {
        MedicalRecordEntry,
        // MedicalRecordList,
        // AddMedicalRecord,
        SpecimenDetails
    },
    props: {
        specimenDisplayID: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            currentSpecimen: {},
            rules: validationRules.rules,
            loadingSpecimen: false,
            panel: null
        };
    },
    filters: {
        formatTasksDate: function(value) {
            return moment.utc(value).format(constants.DATE_FORMAT_NO_TIME);
        },
        formatNonTasksDate: function(value) {
            return moment(value).format(constants.DATE_FORMAT);
        }
    },
    computed: {

        saveError() {
            return this.$store.state.specimenStore.saveError;
        },
        medicalRecordID() {
            return this.$route.params.medicalRecordID;
        },
        specimenID() {
            return this.$route.params.SpecimenID;
        }
    },
    methods: {
        checkEnterKey(event){
            if (event.keyCode === 13){
                this.loadSpecimen();
            }
        },
    },
    created() {

    },
};
</script>
